import { useEffect } from 'react'
import { appDownloadUrl } from 'utils/browser'

export default function Download(): JSX.Element {
  useEffect(() => {
    window.location.href = appDownloadUrl()
  }, [])

  return <></>
}
